export const bonusSchema = (yup) => {
  return {
    amount: yup.number().required("required"),
  };
};

export const bonusInitial = {
  amount: 0,
  operations_id: 2,
};